<template>
  <div class="cookie-container regular">
    <transition name="order-checkout">
      <div class="mask" @touchmove.prevent v-if="visible">
        <div class="cookie-mask mask_content">
          <div class="head">
            <div class="title bold">
              <AutoFitComponent :align="$i18n.locale == 'AR' ? 'right' : 'left'">{{
                $t('cookie.title')
              }}</AutoFitComponent>
            </div>
            <div class="setting btn-link medium" @click="visibleSettings = true">
              {{ $t('cookie.titleSettings') }}
            </div>
          </div>
          <div class="content common-gray-content">
            <i18n path="cookie.desc1" tag="div" class="cookie-desc">
              <a place="0" class="btn-link" :href="cookiePolicyUrl" target="_blank">
                {{ $t('cookie.btnLink') }}</a
              >
            </i18n>
          </div>
          <div class="footer">
            <div class="button" @click="acceptAllCookie">{{ $t('cookie.acceptAll') }}</div>
            <div class="button" @click="acceptOnly">{{ $t('cookie.acceptOnly') }}</div>
          </div>
        </div>
      </div>
    </transition>
    <transition name="order-checkout">
      <div class="mask" @touchmove.prevent v-if="visibleSettings">
        <div class="mask_content cookie-settings-mask">
          <div class="head">
            <div class="title title-settings bold">
              <AutoFitMutilComp
                text-align="center"
                multi-line
                height="100%"
                :max-font-size="0.5067"
                :text="$t('cookie.titleCustom')"
              ></AutoFitMutilComp>
            </div>
            <div class="close" @click="visibleSettings = false"></div>
          </div>
          <div class="content" @touchmove.stop v-touchmove>
            <p class="cookie-desc">{{ $t('cookie.desc') }}</p>
            <p class="cookie-desc">{{ $t('cookie.text') }}</p>
            <div class="detail-body">
              <div class="cookie-details">
                <div
                  class="detail-item"
                  :class="{ active: isShowNecessary }"
                  :style="{ '--content-height': `${necessaryHeight}px` }"
                >
                  <div class="detail-title" @click="isShowNecessary = !isShowNecessary">
                    <div class="txt medium">
                      <AutoFitComponent :align="$i18n.locale == 'AR' ? 'right' : 'left'">{{
                        $t('cookie.btn2')
                      }}</AutoFitComponent>
                    </div>
                    <div class="btn-link">{{ $t('cookie.alwaysActive') }}</div>
                  </div>
                  <div
                    ref="necessary"
                    class="detail-content"
                    :class="initHeight ? 'animate' : 'default'"
                  >
                    <template v-for="(item, index) in cookieStr1">
                      <br v-if="index > 0" />
                      <div
                        :key="index"
                        :class="[
                          'text',
                          `text-${item[1]}`,
                          { 'last-item': index === cookieStr1.length - 1 },
                          { 'first-item': index === 0 },
                        ]"
                      >
                        <template v-if="typeof item[0] === 'string'">
                          {{ item[0] === 'primer.postCode' ? '2.' : '' }}{{ $t(item[0]) }}
                        </template>
                        <template v-else>
                          <template v-for="(citem, i) in item[0]">{{ $t(citem) }}</template>
                        </template>
                      </div>
                    </template>
                  </div>
                </div>
                <div
                  class="detail-item"
                  :class="{ active: isShowFeature }"
                  :style="{ '--content-height': `${featureHeight}px` }"
                >
                  <div class="detail-title" @click="isShowFeature = !isShowFeature">
                    <div class="txt medium">
                      <AutoFitComponent :align="$i18n.locale == 'AR' ? 'right' : 'left'">{{
                        $t('cookie.h1')
                      }}</AutoFitComponent>
                    </div>
                    <FormSwitch v-model="isAllowAll" @click.native.stop />
                  </div>
                  <div
                    ref="feature"
                    class="detail-content"
                    :class="initHeight ? 'animate' : 'default'"
                  >
                    <template v-for="(item, index) in cookieStr2">
                      <br v-if="index > 0" />
                      <div
                        :key="index"
                        :class="[
                          'text',
                          `text-${item[1]}`,
                          { 'last-item': index === cookieStr2.length - 1 },
                          { 'first-item': index === 0 },
                        ]"
                      >
                        <template v-if="typeof item[0] === 'string'">
                          {{ item[0] === 'primer.postCode' ? '2.' : '' }}{{ $t(item[0]) }}
                        </template>
                        <template v-else>
                          <template v-for="(citem, i) in item[0]">{{ $t(citem) }}</template>
                        </template>
                      </div>
                    </template>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="footer">
            <div class="button" @click="saveSettings">{{ $t('cookie.saveSettings') }}</div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import FormSwitch from '@/components/common/form/FormSwitch.vue'
export default {
  components: {
    FormSwitch,
  },
  data() {
    return {
      initHeight: false,
      cookiePolicyUrl: process.env.VUE_APP_COOKIE_POLICY_URL,
      necessaryHeight: 0,
      featureHeight: 0,
      visible: false,
      visibleSettings: false,
      isAllowAll: false,
      activeIndex: 0,
      isShowNecessary: false,
      isShowFeature: false,
      cookieStr1: [
        ['cookie.p1', 2],
        [['cookie.p4', 'cookie.p6'], 3],
        [['cookie.p5', 'cookie.p7'], 3],
      ],
      cookieStr2: [
        ['cookie.p3', 2],
        [['cookie.p4', 'cookie.p10'], 3],
        [['cookie.p5', 'cookie.p11'], 3],
      ],
    }
  },
  computed: {
    ...mapState({
      accept: (state) => state.app.accept,
      acceptAll: (state) => state.app.acceptAll,
    }),
  },
  created() {
    // 如果第一次进入，且有 session_id 且 web_cache 为 0，则接受必要 cookie 设置
    if (this.$route.query.web_cache == '0') {
      if (!this.accept) {
        this.acceptOnly()
      }
      this.$router.replace({
        path: this.$route.path,
        query: {
          ...this.$route.query,
          web_cache: undefined,
        },
      })
    }

    this.$root.Bus.$on('acceptOnly', this.acceptOnly)
    if (process.env.VUE_APP_GAME_ID != 20317 && process.env.VUE_APP_GAME_ID != 20349) {
      this.cookieStr1.push(
        ['cookie.p2', 2],
        [['cookie.p4', 'cookie.p8'], 3],
        [['cookie.p5', 'cookie.p7'], 3]
      )
      this.cookieStr2.push(
        ['primer.postCode', 2],
        [['cookie.p4', 'cookie.zipcodeTxt'], 3],
        [['cookie.p5', 'cookie.p11'], 3]
      )
    }
    this.$root.Bus.$on('showCookie', (fn) => {
      this.visible = true
      if (fn) {
        this.callback = fn
      }
    })
    this.$root.Bus.$on('showCookieSettings', () => {
      this.visibleSettings = true
    })
  },
  watch: {
    visibleSettings(val) {
      if (val) {
        this.isAllowAll = this.acceptAll
        this.$nextTick(() => {
          if (!this.initHeight) {
            this.initHeight = true
            this.necessaryHeight = this.$refs.necessary.offsetHeight
            this.featureHeight = this.$refs.feature.offsetHeight
          }
          this.isShowNecessary = false
          this.isShowFeature = true
        })
      }
    },
  },
  mounted() {
    // 流程：第二次检查后仍无同意 → 拉起 cookie 同意弹窗
    if (!this.accept) {
      setTimeout(() => {
        this.visible = true
      }, 500)
    }
  },
  methods: {
    allow(isAll) {
      if (isAll) {
        this.$store.commit('app/SET_ACCEPT_ALL', true)
      } else {
        this.$store.commit('app/SET_ACCEPT_ALL', false)
      }
      this.$utils.unifiedCookieStorage.setItem('acceptis', true)
      this.$store.commit('app/SET_ACCEPT', true)
      this.visibleSettings = false
      this.visible = false
      if (this.callback) {
        this.callback()
        this.callback = null
      }
    },
    // 接受全部 cookie 设置
    acceptAllCookie() {
      this.allow(true)
    },
    // 接受必要 cookie 设置
    acceptOnly() {
      this.allow(false)
    },
    // 保存 cookie 设置
    saveSettings() {
      if (this.isAllowAll) {
        this.acceptAllCookie()
      } else {
        this.acceptOnly()
      }
    },
  },
}
</script>

<style lang="less" scoped>
.mask_content {
  position: absolute;
  right: 50%;
  bottom: 50%;
  transform: translate(50%, 50%);
  width: 375px;
  height: auto;
  background: #fff;
  border-radius: 16px;
  padding: 0px 12px 12px;
  overflow: hidden;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: stretch;
  /* 或 scroll */
  -ms-overflow-style: none;
  /* IE 和 Edge */
  scrollbar-width: none;
  transition: all 0.2s;

  &.cookie-settings-mask {
    height: 500px;
    .content {
      flex: 1;
      overflow: hidden auto;
      &::-webkit-scrollbar {
        display: none;
      }
      .detail-body {
        flex: 1;
        overflow: hidden;
        display: flex;
        flex-direction: column;
      }
    }
  }

  .head {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 52px;
    position: relative;
    .title {
      width: 234px;
      font-size: 19px;
      color: #000;
      &.title-settings {
        width: 100%;
        height: 52px;
        padding: 0 24px;
        text-align: center;
      }
    }
    .setting {
      font-size: 12px;
    }
    .close {
      position: absolute;
      width: 24px;
      height: 24px;
      top: 14px;
      right: 0;
      cursor: pointer;
      .bg-image('close');
    }
  }

  .content {
    .cookie-desc {
      font-size: 14px;
      line-height: 1.4;
    }
    p {
      padding-bottom: 20px;
    }
  }

  .cookie-details {
    border-radius: 12px;
    background-color: rgba(242, 244, 248, 1);
    padding: 0 12px;
    .detail-item {
      & + .detail-item {
        border-top: 1px solid rgba(217, 217, 217, 1);
      }
      &.active {
        .detail-title {
          &::before {
            transform: translateY(-50%) rotate(90deg);
          }
        }
        .detail-content {
          height: var(--content-height);
        }
      }
    }
    .detail-title {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 12px 0;
      padding-right: 32px;
      position: relative;
      height: 46px;
      cursor: pointer;
      &::before {
        content: '';
        display: block;
        width: 24px;
        height: 24px;
        position: absolute;
        top: 50%;
        right: 0;
        transform: translateY(-50%);
        .bg-image('arr_right_gray');
        transition: transform 0.2s ease-in-out;
      }
      .txt {
        font-size: 14px;
        width: 180px;
      }
    }

    .detail-content {
      height: 0;
      overflow: hidden;
      &.default {
        height: auto !important;
      }
      &.animate {
        transition: height 0.2s ease-in-out;
      }
      .text {
        &.first-item {
          margin-top: 12px;
        }
        &.last-item {
          margin-bottom: 12px;
        }
      }
      .text-2 {
        font-size: 14px;
        font-weight: 500;
        color: #343a3f;
      }
      .text-3 {
        font-size: 14px;
        font-weight: 400;
        color: #62676b;
      }
    }
  }

  .footer {
    padding: 20px 0 8px;
    .button {
      & + .button {
        margin-top: 12px;
      }
    }
  }
}
@media (max-width: 1024px) {
  .mask_content,
  .mask_content.cookie-mask {
    max-height: calc(100% - 50px);
    width: 100%;
    border-radius: 16px 16px 0 0;
    bottom: 0;
    right: 0;
    transform: none;
    overflow: auto;

    &.cookie-settings-mask {
      height: calc(100% - 50px);
    }
  }
}
</style>
